export default "<p>campaign-contacts-add works!</p>\n";